import { collection, getFirestore, doc, addDoc, Timestamp } from 'firebase/firestore';
import React, { useEffect, useState } from 'react';
import PrimaryButton from '../components/buttons/PrimaryButton';
import Input from '../components/inputs/Input';
import { app } from '../firebase'; // Importez votre configuration Firebase
import { isProvider, isRentalManager, useUser } from '../contexts/UserContext';
import { handleUpload } from '../librairies/FirebaseStorage';
import TextareaInput from '../components/inputs/TextareaInput';
import TimeInput from '../components/inputs/TimeInput';
import { dateFromTimestampToString } from '../librairies/Dates';
import FilesInput from '../components/inputs/FilesInput';
import CheckboxInput from '../components/inputs/CheckboxInput';
import DateTimeInput from '../components/inputs/DateTimeInput';
import Label from '../components/texts/Label';

const db = getFirestore(app);
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const MAX_CC_EMAILS = 10;

const buildCcEmails = (currentEmails, pendingInput) => {
  const pending = pendingInput.trim().toLowerCase();
  if (!pending) {
    return { emails: currentEmails, error: "" };
  }
  if (!EMAIL_REGEX.test(pending)) {
    return { emails: currentEmails, error: "Adresse e-mail invalide." };
  }
  if (currentEmails.includes(pending)) {
    return { emails: currentEmails, error: "Cette adresse est déjà ajoutée." };
  }
  if (currentEmails.length >= MAX_CC_EMAILS) {
    return { emails: currentEmails, error: "10 adresses maximum." };
  }
  return { emails: [...currentEmails, pending], error: "" };
};

function AddEvent({onClose, date, listCoownership=[]}) {

  //contexte de l'utilisateur connecté
  const user = useUser();

  const [loader, setLoader] = useState(false);
  const [error, setError] = useState("");
  
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [filename, setFilename] = useState(null);
  const [files, setFiles] = useState([]);

  const [timeBegining, setTimeBegining] = useState("09:00"); 
  const [timeEnd, setTimeEnd] = useState("17:00");

  const [dateTimeBegining, setDateTimeBegining] = useState(new Date(date)); 
  const [dateTimeEnd, setDateTimeEnd] = useState("");

  const [multipleDates, setMultipleDates] = useState(false);
  const [coownershipComiteeTarget, setCoownershipComiteeTarget] = useState(false);
  const [coownerTarget, setCoownerTarget] = useState(false);
  const [tenantTarget, setTenantTarget] = useState(isRentalManager(user.user) ? true : false);

  const [coownership, setCoownership] = useState("");
  const [filteredCoownerships, setFilteredCoownerships] = useState("");
  const [searchTerm, setSearchTerm] = useState('');
  const [ccEmailInput, setCcEmailInput] = useState("");
  const [ccEmails, setCcEmails] = useState([]);

  const [errors, setErrors] = useState({
    title: '',
    file: '',
    timeBegining: '',
    timeEnd: '',
    dateTimeBegining,
    dateTimeEnd, 
    coownership: '',
    target: '',
    ccEmails: '',
  });

  const resetState = () => {
    setError("");
    setTitle("");
    setDescription("");
    setFiles([]);
    setCoownership("");
    setSearchTerm("");
    setCcEmailInput("");
    setCcEmails([]);
    setCoownershipComiteeTarget(false);
    setCoownerTarget(false);
    setTenantTarget(false);
  }

  const handleRemoveFile = (index) => {
    setFiles(prevFiles => prevFiles.filter((_, i) => i !== index));
  };

  useEffect(() => {
    const coownershipsArray = listCoownership.filter((value) =>
      value.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    setFilteredCoownerships(coownershipsArray);
  }, [searchTerm]); 

  /**
   * On crée le document billboard
   * @param {*} fileUrl 
   */
  const addCcEmail = () => {
    const result = buildCcEmails(ccEmails, ccEmailInput);
    if (result.error) {
      setErrors((prev) => ({ ...prev, ccEmails: result.error }));
      return;
    }
    setCcEmails(result.emails);
    setCcEmailInput("");
    setErrors((prev) => ({ ...prev, ccEmails: "" }));
  };

  const removeCcEmail = (email) => {
    setCcEmails((prev) => prev.filter((item) => item !== email));
  };

  const createDoc = async (uploadedUrls, emailsInCopy) => {
    //on envoie les données sur firestore 
    let docCoownership = ""; 

    //calendrier unique ou prestataire
    if(listCoownership.length > 0 || isProvider(user.user)){
      docCoownership = "users/"+user.user.user.uid;
    } else{
      docCoownership = user.user.userData.lastCoownershipLoaded.path;
    }

    const eventsCollection = collection(db, docCoownership+"/events");
    const coownershipreference = doc(db, !isProvider(user.user) || (isProvider(user.user) && coownership === "") ? user.user.userData.lastCoownershipLoaded.path : "coownership/"+coownership);

    try{
      await addDoc(eventsCollection, {
        createdByProvider: isProvider(user.user),
        title: title,
        description:description,
        dateSave: Timestamp.fromDate(new Date()), 
        dateBegining: combineDateAndTime(timeBegining),
        dateEnd: multipleDates ? Timestamp.fromDate(new Date(dateTimeEnd)) : combineDateAndTime(timeEnd),
        multipleDates: multipleDates,
        firstnameCreator: isProvider(user.user) ? "le prestataire "+user.user.userData.company : "le gestionnaire", 
        lastnameCreator: "", 
        status: "accepted",
        idCreator: doc(db, 'users/' + user.user.user.uid),
        files: uploadedUrls,
        coownership: coownershipreference,
        coownershipComiteeTarget: coownershipComiteeTarget,
        coownerTarget: coownerTarget,
        tenantTarget: tenantTarget,
        ccEmails: emailsInCopy,
      });
    } catch(err){
      setError("Une erreur est survenue, impossible d'ajouter l'événement");
    }
  }

  // Fonction pour ajouter l'heure sélectionnée à la date et obtenir un timestamp
  const combineDateAndTime = (time) => {
    const [hours, minutes] = time.split(':');
  
    // Création de la date en heure française
    const combinedDate = new Date(date);
    combinedDate.setHours(hours);
    combinedDate.setMinutes(minutes);
    combinedDate.setSeconds(0);
    combinedDate.setMilliseconds(0);
  
    // Convertir la date en heure française en utilisant le fuseau Europe/Paris
    const combinedDateInFrance = new Date(
      combinedDate.toLocaleString("en-US", { timeZone: "Europe/Paris" })
    );
  
    return Timestamp.fromDate(combinedDateInFrance); // Conversion en Firestore Timestamp
  };

  const handleSubmit = async (e)  => {
    e.preventDefault();
    
    // Validation des champs
    const newErrors = {};

    if (!title) {
      newErrors.title = "Le titre est requis.";
    }

    if (!timeBegining) {
      newErrors.timeBegining = "L'heure de début est requise.";
    }

    if (!timeEnd) {
      newErrors.timeEnd = "L'heure de fin est requise.";
    }

    if(listCoownership.length > 0 && coownership === ""){
      newErrors.coownership = "Vous devez sélectionner une copropriété.";      
    }

    if (!coownerTarget && !coownershipComiteeTarget && !tenantTarget) {
      newErrors.target = "Vous devez sélectionner au minimum une cible pour l'événement.";
    }

    const ccResult = buildCcEmails(ccEmails, ccEmailInput);
    if (ccResult.error) {
      newErrors.ccEmails = ccResult.error;
    }


    if (Object.keys(newErrors).length === 0) {
      console.log("Données du formulaire valides.");

      try{
        setLoader(true);
        if(files.length > 0){
          

          let uploadedUrls = [];

          for (const file of files) {
    
            let url = await handleUpload("events/", file);

            const typeMedia = (file.type == "application/pdf") ? "pdf" : "image";
    
            let obj = {url:url, typeMedia:typeMedia};
            
            uploadedUrls.push(obj);
          }
          await createDoc(uploadedUrls, ccResult.emails);
        }else{
          await createDoc(null, ccResult.emails); 
        }

        setLoader(false);
        //on remet tous les states par défaut
        resetState(); 

        //on close la popup
        onClose(); 

      } catch(err){
        console.log(err)
        setError("Une erreur est survenue, impossible d'ajouter l'événement");
        setLoader(false);
      }
    } else {
      // Afficher les erreurs
      setErrors(newErrors);
    }
  };

  
  /**
   * Modification des fichiers
   * @param {*} e 
   */
  const handleFilesChange = (e) => {
    if (e.target.files.length > 0) {
      const selectedFiles = Array.from(e.target.files); // Convertir FileList en tableau
      setFiles(prevFiles => [...prevFiles, ...selectedFiles]); // Ajouter au state
    }
  };


  return (
    <div id="authentication-modal" tabindex="-1" aria-hidden="true" className="mx-auto w-full fixed inset-0 flex items-center justify-center overflow-auto">
      <div className="relative w-full max-w-md max-h-full">
        <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <button type="button" onClick={onClose} className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white" data-modal-hide="authentication-modal">
            <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
            </svg>
            <span className="sr-only">Close modal</span>
          </button>
          <div className="px-6 py-6 lg:px-8">
            <h3 className="mb-4 text-xl font-medium text-gray-900 dark:text-white">Ajouter un événement le {dateFromTimestampToString(Math.floor(date.getTime()/1000))}</h3>

            <form onSubmit={handleSubmit}>

              <div className='mb-6'>

                {listCoownership.length > 0 ? (
                  <div className='my-6'>
                    <input
                      type="text"
                      placeholder="Rechercher une copropriété"
                      value={searchTerm}
                      onChange={(event) => setSearchTerm(event.target.value)}
                      className=" p-2 border rounded-xl w-full focus:border-primary"
                    />
                    <select id="account" onChange={(e) => setCoownership(e.target.value)} 
                     className="my-2 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                      <option selected>Sélectionnez une copropriété</option>
                      {filteredCoownerships.length > 0 ? (
                        filteredCoownerships.map((value) => {
                          return (
                            <option value={value.id}>{value.name}</option>
                          )
                        })
                      ) : null }
                    </select>

                    {errors.coownership && (
                      <p className="text-red-500 text-sm mt-1">{errors.coownership}</p>
                    )}
                  </div>
                ) : null }

                <div className='border-b border-gray mt-0.5 mb-2'></div>
                  <div className='mt-4'>
                    <CheckboxInput id={"multipleDates"} label={"Événement sur plusieurs jours"} name={"multipleDates"} checked={multipleDates} onChange={() => setMultipleDates(!multipleDates)}/>
                  </div>

                  
                    <div className='flex justify-between'>
                      <TimeInput id={"timeBegining"} label={"heure de début"} value={timeBegining} onChange={(time) => setTimeBegining(time)} error={errors.timeBegining}/>
                      {!multipleDates && (
                        <TimeInput id={"timeEnd"} label={"heure de fin"} value={timeEnd} onChange={(time) => setTimeEnd(time)} error={errors.timeEnd}/>
                      )}
                    </div>
                 
                  
                  {multipleDates && (
                    <div className=''>
                      <DateTimeInput id={"dateTimeEnd"} label={"Date de fin"} value={dateTimeEnd} onChange={setDateTimeEnd} error={errors.dateTimeEnd}/>
                    </div>
                  )}

                  <div className="mt-4">
                    <Label text={"Événement destiné à"} required={true} />
                    <div className='flex justify-between'>
                      <CheckboxInput id={"coownershipComiteeTarget"} name={"coownershipComiteeTarget"} label={"CS"} checked={coownershipComiteeTarget} onChange={() => setCoownershipComiteeTarget(!coownershipComiteeTarget)} disabled={isRentalManager(user.user)} />
                      <CheckboxInput id={"coownerTarget"} name={"coownerTarget"} label={"Copropriétaires"} checked={coownerTarget} onChange={() => setCoownerTarget(!coownerTarget)} disabled={isRentalManager(user.user)} />
                      <CheckboxInput id={"tenantTarget"} name={"tenantTarget"} label={"Locataires"} checked={tenantTarget} onChange={() => setTenantTarget(!tenantTarget)} disabled={isRentalManager(user.user)} />
                    </div>
                    {errors.target && (
                      <p className="text-red-500 text-sm mt-1">{errors.target}</p>
                    )}
                  </div>

                  <Input id={"title"} label={"Titre"} type={"text"} name={"title"} value={title} onChange={(event) => setTitle(event.target.value)} error={errors.title} />
                  <TextareaInput id={"description"} label={"Description"} name={"description"} value={description} onChange={(event) => setDescription(event.target.value)} required={false}/>

                  <div className="mt-4">
                    <Label text={"E-mails en copie"} />
                    <p className="text-xs text-gray-500 mb-2">Ces adresses recevront le mail de création en copie (10 maximum).</p>
                    <div className="flex gap-2">
                      <input
                        type="email"
                        id="ccEmail"
                        name="ccEmail"
                        value={ccEmailInput}
                        onChange={(event) => setCcEmailInput(event.target.value)}
                        onKeyDown={(event) => {
                          if (event.key === "Enter") {
                            event.preventDefault();
                            addCcEmail();
                          }
                        }}
                        placeholder="adresse@exemple.com"
                        disabled={ccEmails.length >= MAX_CC_EMAILS}
                        className={`mt-1 py-1.5 px-2 block w-full rounded border border-gray-300 focus:border-primary ${errors.ccEmails ? "border-red-500" : ""}`}
                      />
                      <button
                        type="button"
                        onClick={addCcEmail}
                        disabled={ccEmails.length >= MAX_CC_EMAILS}
                        className="mt-1 px-3 py-1.5 text-sm text-white bg-primary rounded hover:bg-secondary disabled:opacity-60 disabled:cursor-not-allowed"
                      >
                        Ajouter
                      </button>
                    </div>
                    {errors.ccEmails && (
                      <p className="text-red-500 text-sm mt-1">{errors.ccEmails}</p>
                    )}
                    {ccEmails.length > 0 && (
                      <ul className="mt-2 space-y-1">
                        {ccEmails.map((email) => (
                          <li key={email} className="flex items-center justify-between text-sm bg-gray-50 border border-gray-200 rounded px-2 py-1">
                            <span>{email}</span>
                            <button type="button" onClick={() => removeCcEmail(email)} className="text-red-500 text-xs">
                              Retirer
                            </button>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>

                  <div className="mt-4">
                    <FilesInput id={"affichage"} name={"affichage"} label={"Images ou PDF"} files={files} onChange={handleFilesChange} onRemoveFile={handleRemoveFile} error={errors.file} fileAccepted={"image/*,application/pdf"} />
                  </div>
                </div>

                <div className="text-center">
                  <PrimaryButton type={"submit"} value={"Ajouter"} loading={loader} />
                </div>

                {error !== "" ? (
                  <p className='justify-center flex my-1 text-red-500'>{error}</p>
                ) : null}
              
            </form>

          </div>
        </div>
      </div>
    </div> 
  );
}

export default AddEvent;